import Vue from 'vue'
import App from 'client/components/app.vue'
import Router from './router.js'
import store from './store/store.js'
import { data } from 'jquery'

// Import standard Murdoch components globally
// TODO: Manually define which components to include (if/when the number/variety grows larger than most projects use)
const layout = 'custom'
const requireContext = require.context('client/components/murdoch', true, /.*\.vue$/)
const baseComponents = requireContext.keys()
   // Only keep top-level & matching layout sub-folder
   .filter(file => {
      let bits = file.split(/[\\\/]/)
      return bits.length == 2 || bits[1] == layout
   })
   .map(file => [file.replace(/(^.*\/)|(\.vue$)/g, ''), requireContext(file)])
   .reduce((components, [name, component]) => {
      components[name] = component.default || component
      return components
   }, {})
Object.keys(baseComponents).forEach(comp => {
   Vue.component(comp, baseComponents[comp]) //globally declares vue components
})

// Extra Style/Layout specific global components
// Vue.component('PageFooter', require('client/components'))
class VueJSUI {
   static init(baseUrl) {
      const router = Router.init(baseUrl)
      new Vue({
         el: '#main-content',
         router,
         store,
         render: h => h(App)
      })
   }
}

module.exports = VueJSUI
